// extracted by mini-css-extract-plugin
export default {"sp__tooltip":"projectInfo_sp__tooltip__nYIfj","sp__tooltipWrapper":"projectInfo_sp__tooltipWrapper__HMzqU","sp__tooltipItem":"projectInfo_sp__tooltipItem__umBaj"};